/**
 * /audit/$trustId — external-auditor per-trust read-only drill-down (route shell).
 *
 * Screen impl in `./$trustId-screen.tsx`, lazy-loaded so the auditor surface
 * stays out of the trustee/admin initial payload (a normal user never lands here).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/audit/$trustId')({
  component: lazyRouteComponent(() => import('./$trustId-screen'), 'AuditTrust'),
});
